<template>
    <div class="form-step-container">
        <slot name="controls"></slot>

        <slot name="children"></slot>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from "vue";
    export default defineComponent({
        name: "FormStepComponent"
    });
</script>
